import React from 'react';

import ForgotPasswordForm from 'components/forgot-password/form';
import ImagePanel from '@youship/components/objects/image-panel';
import { FormattedMessage } from 'react-intl';

import './styles.scss';

const ForgotPassword = () => (
  <div className="forgot-password-area">
    <ImagePanel />
    <div className="container">
      <div className="row justify-content-center">
        <div className="col col-12 col-sm-6 offset-sm-6">
          <h1 className="forgot-password-area__title">
            <FormattedMessage id="login.forgot_password.title" />
          </h1>
          <div className="forgot-password-area__description">
            <FormattedMessage id="login.forgot_password.description" />
          </div>
          <div className="row">
            <div className="col col-12 col-lg-10">
              <ForgotPasswordForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default ForgotPassword;
